(function () {
  const STORAGE_KEY = "manual_gearbox_verified_v4";

  const overlay = document.getElementById("gearboxOverlay");
  const plate = document.getElementById("gearPlate");
  const knob = document.getElementById("gearKnob");
  const message = document.getElementById("gearMessage");
  const startEl = document.getElementById("gearStart");
  const targetEl = document.getElementById("gearTarget");

  const points = {
    1: { x: 85, y: 75, col: 1 },
    2: { x: 85, y: 245, col: 1 },
    3: { x: 160, y: 75, col: 2 },
    4: { x: 160, y: 245, col: 2 },
    5: { x: 235, y: 75, col: 3 },
    6: { x: 235, y: 245, col: 3 },

    n1: { x: 85, y: 160, col: 1 },
    n2: { x: 160, y: 160, col: 2 },
    n3: { x: 235, y: 160, col: 3 }
  };

  const segments = [
    ["1", "n1"],
    ["n1", "2"],
    ["3", "n2"],
    ["n2", "4"],
    ["5", "n3"],
    ["n3", "6"],
    ["n1", "n2"],
    ["n2", "n3"]
  ];

  function randomGear() {
    return Math.floor(Math.random() * 6) + 1;
  }

  let startGear = randomGear();
  let targetGear = randomGear();

  while (targetGear === startGear) {
    targetGear = randomGear();
  }

  startEl.textContent = startGear;
  targetEl.textContent = targetGear;

  function neutralForGear(gear) {
    return "n" + points[gear].col;
  }

  function buildCorrectRoute(start, target) {
    const route = [String(start)];
    const startNeutral = neutralForGear(start);

    route.push(startNeutral);

    const startCol = points[start].col;
    const targetCol = points[target].col;

    if (startCol < targetCol) {
      for (let c = startCol + 1; c <= targetCol; c++) {
        route.push("n" + c);
      }
    } else if (startCol > targetCol) {
      for (let c = startCol - 1; c >= targetCol; c--) {
        route.push("n" + c);
      }
    }

    route.push(String(target));

    return route.filter((item, index, arr) => {
      return index === 0 || item !== arr[index - 1];
    });
  }

  const correctRoute = buildCorrectRoute(startGear, targetGear);

  let dragging = false;
  let knobX = points[startGear].x;
  let knobY = points[startGear].y;
  let currentNode = String(startGear);
  let visitedRoute = [currentNode];
  let startedAt = 0;
  let moveCount = 0;
  let hasFailed = false;
  let completed = false;

  function setKnob(x, y) {
    knobX = x;
    knobY = y;
    knob.style.left = x + "px";
    knob.style.top = y + "px";
  }

  function distance(a, b) {
    return Math.sqrt(
      Math.pow(a.x - b.x, 2) +
      Math.pow(a.y - b.y, 2)
    );
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function pointerPosition(e) {
    const rect = plate.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    };
  }

  function projectPointToSegment(p, a, b) {
    if (a.x === b.x) {
      return {
        x: a.x,
        y: clamp(p.y, Math.min(a.y, b.y), Math.max(a.y, b.y))
      };
    }

    if (a.y === b.y) {
      return {
        x: clamp(p.x, Math.min(a.x, b.x), Math.max(a.x, b.x)),
        y: a.y
      };
    }

    return p;
  }

  function nearestValidPoint(pointer) {
    let best = null;
    let bestDistance = Infinity;
    let bestSegment = null;

    segments.forEach(function (seg) {
      const a = points[seg[0]];
      const b = points[seg[1]];
      const projected = projectPointToSegment(pointer, a, b);
      const d = distance(pointer, projected);

      if (d < bestDistance) {
        bestDistance = d;
        best = projected;
        bestSegment = seg;
      }
    });

    return {
      point: best,
      segment: bestSegment,
      distance: bestDistance
    };
  }

  function nearestNodeToKnob() {
    let bestNode = null;
    let bestDistance = Infinity;

    Object.keys(points).forEach(function (key) {
      const d = distance({ x: knobX, y: knobY }, points[key]);

      if (d < bestDistance) {
        bestDistance = d;
        bestNode = key;
      }
    });

    return {
      node: bestNode,
      distance: bestDistance
    };
  }

  function normalizeNode(node) {
    return String(node);
  }

  function addVisitedNode(node) {
    node = normalizeNode(node);

    if (visitedRoute[visitedRoute.length - 1] !== node) {
      visitedRoute.push(node);
      currentNode = node;

      if (!routeIsStillCorrect()) {
        fail("Wrong path. Try again.");
        return;
      }

      if (node === String(targetGear)) {
        completed = true;
        verifyHuman();
      }
    }
  }

  function routeIsStillCorrect() {
    for (let i = 0; i < visitedRoute.length; i++) {
      if (visitedRoute[i] !== correctRoute[i]) {
        return false;
      }
    }

    return true;
  }

  function fail(text) {
    if (completed) return;

    hasFailed = true;
    dragging = false;

    message.textContent = text || "Wrong path. Try again.";
    message.className = "error";

    setTimeout(function () {
      resetChallenge();
    }, 700);
  }

  function resetChallenge() {
    knobX = points[startGear].x;
    knobY = points[startGear].y;
    currentNode = String(startGear);
    visitedRoute = [currentNode];
    hasFailed = false;
    completed = false;
    setKnob(knobX, knobY);

    message.textContent = "Tip: shift from " + startGear + " to " + targetGear + " using the gearbox lines.";
    message.className = "";
  }

  function verifyHuman() {
    localStorage.setItem(STORAGE_KEY, "true");

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "human_gearbox_completed",
      human_verified: true,
      gearbox_from: startGear,
      gearbox_to: targetGear,
      gearbox_route: correctRoute.join("-")
    });

    message.textContent = "Verified! You can now continue.";
    message.className = "success";

    setTimeout(function () {
      overlay.style.display = "none";
    }, 800);
  }

  knob.addEventListener("pointerdown", function (e) {
    dragging = true;
    hasFailed = false;
    completed = false;
    startedAt = Date.now();
    moveCount = 0;

    knob.setPointerCapture(e.pointerId);

    message.textContent = "Keep dragging until you reach " + targetGear + ".";
    message.className = "";
  });

  knob.addEventListener("pointermove", function (e) {
    if (!dragging || hasFailed || completed) return;

    moveCount++;

    const pointer = pointerPosition(e);
    const nearest = nearestValidPoint(pointer);

    setKnob(nearest.point.x, nearest.point.y);

    const nodeResult = nearestNodeToKnob();

    if (nodeResult.distance < 18) {
      addVisitedNode(nodeResult.node);
    }
  });

  knob.addEventListener("pointerup", function () {
    if (completed) return;

    dragging = false;

    const duration = Date.now() - startedAt;

    if (duration < 350 || moveCount < 5) {
      fail("Too fast. Try again.");
      return;
    }

    if (currentNode !== String(targetGear)) {
      fail("You released before reaching the target gear.");
    }
  });

  function showGate() {
    if (localStorage.getItem(STORAGE_KEY) !== "true") {
      overlay.style.display = "flex";
    }
  }

  setKnob(knobX, knobY);
  resetChallenge();
  setTimeout(function () {
    showGate();
  }, 10000);
})();